import { BoxIcon, UserContributorIcon, UserGuestIcon } from 'assets/icons';
import { Button, ButtonStyle } from 'common/button';
import { InvitationStep } from 'common/invite-to-record-process/invite-to-record-process';
import { goToPage, RouteName } from 'routes';
import styles from './empty-page-content.module.scss';

type EmptyPageContentProps = {
  notifyInviteToRecordProcess?: (step: InvitationStep) => void;
  vaultsCollaborators: VaultCollaboratorsType[];
};

const EmptyPageContent: React.FC<EmptyPageContentProps> = ({
  notifyInviteToRecordProcess,
  vaultsCollaborators,
}) => {
  const title = vaultsCollaborators.length
    ? 'No collaborators yet'
    : 'No vaults yet.';
  const showButtons = vaultsCollaborators.length > 0;

  return (
    <div className={styles.emptyPage}>
      <BoxIcon className={styles.boxIcon} />
      <div className={styles.emptyPageTexts}>
        <p className="text__title1__gray700">{title}</p>

        <span className="text__body__regular__medium__gray700">
          {vaultsCollaborators.length ? (
            'Invite editors and contributors to your vaults to give them the ability to add content.'
          ) : (
            <p>
              Go to the{' '}
              <Button
                buttonStyle={ButtonStyle.PrimaryGhostLink}
                onClick={() => {
                  goToPage(RouteName.Vaults);
                }}
              >
                vaults page
              </Button>{' '}
              to create your first vault. Then invite editors and contributors
              to your vaults to give them the ability to add content.
            </p>
          )}
        </span>
      </div>
      {showButtons && (
        <div className={styles.buttons}>
          <button
            className={styles.inviteButton}
            type="button"
            onClick={() => {
              notifyInviteToRecordProcess?.(InvitationStep.inviteContributors);
            }}
          >
            <div className={styles.inviteButtonIcon}>
              <UserContributorIcon />
            </div>
            <div className={styles.inviteButtonText}>
              <span className="text__body__bold__large__gray700">
                Invite editor
              </span>
              <p className="text__body__regular__medium__gray700">
                Manage all aspects of the vault, except subscription and
                payment.
              </p>
            </div>
          </button>
          <button
            className={styles.inviteButton}
            type="button"
            onClick={() => {
              notifyInviteToRecordProcess?.(InvitationStep.inviteGuests);
            }}
          >
            <div className={styles.inviteButtonIcon}>
              <UserGuestIcon />
            </div>
            <div className={styles.inviteButtonText}>
              <span className="text__body__bold__large__gray700">
                Invite contributor
              </span>
              <p className="text__body__regular__medium__gray700">
                Can only upload or record content - no editing or viewing.
              </p>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export { EmptyPageContent };
